import React from 'react';
import { Backdrop, CircularProgress, useTheme } from '@mui/material';
import { useLoading } from '../context/LoadingContext';

const LoadingSpinner: React.FC = () => {
  const { loading } = useLoading();
  const theme = useTheme();

  return (
    <Backdrop sx={{ color: theme.palette.primary.main, zIndex: (theme) => theme.zIndex.modal + 1 }} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingSpinner;